import { render, staticRenderFns } from "./ContactSection.vue?vue&type=template&id=5286e3cd&scoped=true"
var script = {}
import style0 from "./ContactSection.vue?vue&type=style&index=0&id=5286e3cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286e3cd",
  null
  
)

export default component.exports